// 配置子应用端口
export const routeObj = {
  organization: 7301,
  accountWorkspace: 7302,
  accountCustomer: 7303,
  accountPersonal: 7304,
  permission: 7305,
  appCentre: 7306,
  appManage: 7307,
  sourceLibrary: 7308,
  groupsSpace: 7309,
  baseDataManage: 7310,
  sourceManage: 7311,
  groupsSpaceConfig: 7312,
  initializeConfig: 7313,
  prepareLesson: 7314,
  myGoods: 7315,
  vipStrategy: 7316,
  ordersManager: 7317,
  editHomeweb: 7318,
  classPhoto: 7319,
  weather: 7320,
  ksResource: 7321,
  externalChannel: 7322,
  manageChannel: 7323,
  manageTopic: 7324,
  specialTopic: 7325,
  manageAddress: 7326,
  chatgpt: 7327,
  manageActivity: 7328,
  classSetting: 7329,
  classInteraction: 7330,
  classReports: 7331,
  activity: 7332,
  learnCentre: 7333,
  expertLibrary: 7334,
  evaluate: 7335,
  learningTools: 7336,
  certificateEditor: 7337,
  classManage: 7338,
  certificateManage: 7339,
  evaluateSystemQuota: 7340,
  evaluateAgencyManage: 7341,
  inspirationCentre: 7342,
  classStuReports: 7343,
  comprehensiveEvaluate: 7344,
  orgSourceManage: 7345,
  parentsManage: 7346,
  chatManage: 7347,
  educationalInfo: 7348,
  chatQa: 7349,
  todoList: 7350,
  schoolSourceLib: 7351,
  classNotice: 7352,
  spokenTraining: 7353,
  dataView: 7354,
  typicalExercises: 7355,
  chatAi: 7356,
  cloudNotes: 7357,
  clientDownload: 7358,
  classPortal: 7359,
  applyApp: 7360,
  manageSchoolGroup: 7361,
  manageParentsLessons: 7362,
  parentsLessons: 7363,
  limitUsageApp: 7364,
  hostelManage: 7365,
  timeTable: 7366,
  stuTimeTable: 7367,
}

// 获取无界加载的子应用url，应用信息不完整时返回空串（配合调用方 v-if 兜底，避免渲染崩溃）
export const getAppUrl = (appProps) => {
  const isProduction = process.env.NODE_ENV === 'production'
  if (isProduction) {
    return appProps?.projectUrl ? `//${location.host + appProps.projectUrl}` : ''
  }
  const port = routeObj[appProps?.projectName]
  return port ? `//localhost:${port}` : ''
}
